$(document).ready(function () {
  $(document).on("click", "#signIn_button", function (e) {
    e.preventDefault();
  
    var email = $("[id='CustomerEmail']").val();
    var password = $("[id='CustomerPassword']").val();

    var hasError = false;

    if (email.trim() === "") {
      hasError = true;
      $(".error-message-email").css("display", "block");
    } else {
      $(".error-message-email").css("display", "none");
    }

    if (password.trim() === "") {
      hasError = true;
      $(".error-message-password").css("display", "block");
    } else {
      $(".error-message-password").css("display", "none");
    }

    if (!hasError) {
      $('#signIn_button').addClass("loading");
      var data = {
        username: email,
        password: password,
      };

      $.post(
        "https://unahcoapi.unahco.com.ph/api/authenticate",
        data,
        function (response) {
          try {
            var details = jQuery.parseJSON(response);

            if (
              details.data &&
              details.data.customerAccessTokenCreate &&
              details.data.customerAccessTokenCreate.customerAccessToken &&
              details.data.customerAccessTokenCreate.customerAccessToken
                .accessToken
            ) {
              $.post(
                "https://unahcoapi.unahco.com.ph/api/add_record",
                data,
                function (response) {
                  if (response && response.trim() != "failed") {
                    $(".customer.login").css("display", "none");
                    $(".container-otp").css("display", "block");
                    $("#email-address").append($("[id='CustomerEmail']").val());
                    $(".container-otp").attr("data-key", response.trim());
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                    });
                    $('#signIn_button').removeClass("loading");
                  }
                }
              );
            } else {
              Swal.fire({
                icon: "error",
                title: "Login Failed",
                html: "Your email or password is incorrect.<br> Please try again.",
              });
              $('#signIn_button').removeClass("loading");
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
            $('#signIn_button').removeClass("loading");
          }
        }
      );
    }
  });

  $(document).on("click", "#verify-otp", function (e) {

    $('#verify-otp').addClass("loading");
    
    const otp = Array.from(inputs)
      .map((input) => input.value)
      .join("");
    if (otp.length === 6) {
      var OTPkeys = otp;
      var detailsForToken = {
        username: $("[id='CustomerEmail']").val(),
        key: $(".container-otp").data("key"),
        otp: OTPkeys,
      };

      $.post(
        "https://unahcoapi.unahco.com.ph/api/authenticateOTP",
        detailsForToken,
        function (response) {
          if (response.trim().length > 0 && response.trim() != "failed") {
            var detailsForLogin = {
              "customer[email]": $("[id='CustomerEmail']").val(),
              "customer[password]": $("[id='CustomerPassword']").val(),
              form_type: "customer_login",
              utf8: "✓",
              checkout_url: "/",
            };

            $.post("/account/login", detailsForLogin, function (response) {
              const loginTimeKey = 'customerLoginTime';
              const customer = 'c_log';
              localStorage.setItem(customer, 1);
              localStorage.setItem(loginTimeKey, new Date().getTime());
              window.location.href = "/";
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "OTP not match, please try again.",
            });
            $('#verify-otp').removeClass("loading");
          }
        }
      );
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter 6-digit OTP.",
      });
      $('#verify-otp').removeClass("loading");
    }
  });
});

$("#eye-reveal").on("click", function (event) {
  event.preventDefault();

  var $passwordField = $("#CustomerPassword");
  var $openEye = $("#eye-icon-open");
  var $closedEye = $("#eye-icon-closed");

  // Toggle the password visibility
  if ($passwordField.attr("type") === "password") {
    $passwordField.attr("type", "text"); // Show the password

    // Show open eye, hide closed eye
    $openEye.show();
    $closedEye.hide();
  } else {
    $passwordField.attr("type", "password"); // Hide the password

    // Show closed eye, hide open eye
    $openEye.hide();
    $closedEye.show();
  }
});

const inputs = document.querySelectorAll('.otp-input input');
const timerDisplay = document.getElementById('timer');
const resendLink = document.querySelector('.resend-link');

inputs.forEach((input, index) => {
    input.addEventListener('input', (e) => {
        if (e.target.value.length > 1) {
            e.target.value = e.target.value.slice(0, 1);
        }
        if (e.target.value.length === 1) {
            if (index < inputs.length - 1) {
                inputs[index + 1].focus();
            }
        }
    });

    input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !e.target.value) {
            if (index > 0) {
                inputs[index - 1].focus();
            }
        }
        if (e.key === 'e') {
            e.preventDefault();
        }
    });
});
